import axios from 'axios'

const request = axios.create({
  // baseURL:'http://127.0.0.1:3000'
  baseURL:'http://47.119.123.95:3000'
})

export default request